import React from "react";
import { ReactComponent as Clock } from "../../assets/icons/clock-white.svg";
import { Link } from "react-router-dom";

export const BlogCard2 = ({
  id,
  image,
  title,
  readtime,
  category,
  caption,
  style,
  clickable = true
}) => {
  return (
    <div
      style={{
        width: "calc(50% - 25px)",
        minWidth: "300px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        ...style,
      }}
      data-aos="fade"
    >
      <div
        style={{
          width: "100%",
          aspectRatio: "16/9",
          borderRadius: "8px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Link
          to={clickable ? `/resource/${id}` : "#"}
          onClick={(e) => {
            if (!clickable) e.preventDefault();
          }}
          style={{ textDecoration: "none", color: "black" }}
        >
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "8px",
            }}
            src={image}
            alt={title}
          />
        </Link>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            position: "absolute",
            bottom: "20px",
            left: "20px",
          }}
        >
          {readtime && (
            <>
              <Clock width="16" height="16" />
              <p
                style={{ fontSize: "16px", color: "white", lineHeight: "1.4" }}
              >
                {readtime}
              </p>
            </>
          )}

          {category && (
            <p
              style={{
                fontSize: "12px",
                color: "white",
                padding: "4px 8px",
                borderRadius: "50px",
                backgroundColor: "red",
              }}
            >
              {category}
            </p>
          )}
        </div>
      </div>

      <Link
        to={`/resource/${id}`}
        style={{ textDecoration: "none", color: "black" }}
      >
        <p
          style={{ fontSize: "18px", fontWeight: "bold", lineHeight: "1.4" }}
          onMouseEnter={(e) => (e.target.style.color = "#107988")}
          onMouseLeave={(e) => (e.target.style.color = "black")}
        >
          {title}
        </p>
      </Link>
      <p style={{ fontSize: "16px", color: "#545454", lineHeight: "1.4" }}>
        {caption}
      </p>
    </div>
  );
};